import styled from 'styled-components';

import Card from '../../Card';


export const StyledCard = styled(Card)`
  .expandable-table {
    background-color: unset;
    border: none;

    div > div > div > header {
      background-color: #1a1a1a;
    }

    div > div > div > div {
      background-color: #1a1a1a;
    }

    div > div > div > div > div {
      outline: none;
    }
  }

  @media all and (max-width: 1200px) {
   h2.title {
     font-size: 22px;
   }
  }
`;

export const PerformanceSummary = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin: 30px 0;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h3 {
      color: #3ee9f7;
      text-align: center;
    }

    p {
      color: white;
      margin: 15px 0 0;
    }
  }

  @media all and (max-width: 1200px) {
    h3 {
      font-size: 16px;
    }
    p {
      font-size: 
    }
   }
`;

export const ExpandedRowContent = styled.div`
  padding: 30px;

  h4 {
    font-size: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DataCentre/AttemptPerformance/AttemptPerformance.styles.ts